import React from "react";
import { Button, Typography, CircularProgress, Box } from "@mui/material";
import Modal from "../layout/Modal";

const ConfirmationModal = ({
  show,
  handleClose,
  handleConfirm,
  title,
  body,
  buttonLabel,
  buttonLabelSecondary,
  buttonStyle,
  loading,
  hideButton = false,
  width,
  hideConfirmButton = false,
}) => {
  const confirmLabel = buttonLabel || "Confirm";
  const cancelLabel = buttonLabelSecondary || "Cancel";
  const confirmColor = buttonStyle || "error";

  const renderBody = () => {
    const fallback = "Are you sure you want to proceed?";
    if (!body) return <Typography variant="body2">{fallback}</Typography>;
    if (typeof body === "string") return <Typography variant="body2">{body}</Typography>;
    return body;
  };

  const renderActions = () => (
    <>
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleClose}
        disabled={loading}
      >
        {hideConfirmButton ? "Close" : cancelLabel}
      </Button>

      {!hideConfirmButton && (
        <Button
          color={confirmColor}
          variant="contained"
          onClick={handleConfirm}
          disabled={loading}
          title={confirmLabel}
          startIcon={
            loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : null
          }
        >
          {confirmLabel}
        </Button>
      )}
    </>
  );

  return (
    <Modal
      open={show}
      width={width || "sm"}
      handleClose={() => {
        if (!loading) handleClose();
      }}
      modalTitle={title || "Confirm"}
      action={renderActions}
    >
      <Box sx={{ minHeight: 80, width: '100%', overflow: 'hidden' }}>
        {renderBody()}
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;